import React, { useState, useEffect } from "react";
import axios from "axios";
import { useOutletContext, useNavigate } from "react-router-dom";
import { MaterialReactTable } from "material-react-table";
function RegisteredUsers() {
  const [userData, setUserData] = useState([]);
  const { setGlobalLoading, token } = useOutletContext();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate();

  useEffect(() => {
    const fetchRegisteredUsers = async () => {
      try {
        setGlobalLoading(true);
        const res = await axios.get(`${API_BASE_URL}/employeeinfos/joblist/`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        setUserData(res.data.registeredusers || []);
        console.log(res.data.registeredusers);
      } catch (err) {
        console.error("Error fetching registered users:", err);
        setUserData([]);
      } finally {
        setGlobalLoading(false);
      }
    };

    fetchRegisteredUsers();
  }, [API_BASE_URL, token, setGlobalLoading]);

  const columns = [
    {
      accessorKey: "photo", // This should match the key from your backend
      header: "Picture",
      size: 80,
      Cell: ({ row }) => {
        const photo = row.original.photo;
        const imageUrl = photo
          ? `https://pinepositivemoves.com/files/media/${photo}` // Your actual image URL base
          : "https://smarthr.dreamstechnologies.com/html/template/assets/img/users/user-39.jpg"; // Fallback image

        return (
          <img
            src={imageUrl}
            alt="Profile"
            style={{
              width: "35px",
              height: "35px",
              borderRadius: "50%",
              objectFit: "cover",
            }}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src =
                "https://yoyo.com/html/template/assets/img/users/user-39.jpg";
            }}
          />
        );
      },
    },

    { accessorKey: "Fullname", header: "Full Name", size: 150 },
    { accessorKey: "designation", header: "Designation", size: 130 },
    { accessorKey: "worklocation", header: "Work Location", size: 130 },
    { accessorKey: "email", header: "Email", size: 180 },
    { accessorKey: "phone", header: "Phone", size: 130 },
    { accessorKey: "role_type", header: "Role Type", size: 130 },
    { accessorKey: "doj", header: "Date of Joining", size: 130 },
    {
      header: "Actions",
      id: "actions",
      size: 150,
      Cell: ({ row }) => (
        <button
          className="btn btn-sm btn-outline-secondary"
          onClick={() =>
            navigate(
              `/employeeinfo/registeredView/${row.original.id}`,
            )
          }
        >
          View Details
        </button>
      ),
    },
  ];

  return (
    <div className="content">
      <div className="card">
        <div className="card-header d-flex align-items-center flex-wrap gap-2">
          <h5 className="mb-0">Registered Users</h5>
        </div>

        <div className="card-body">
          {userData.length === 0 ? (
            <p className="text-muted">No registered users found.</p>
          ) : (
            <MaterialReactTable
              columns={columns}
              data={userData}
              enableColumnOrdering
              enableFilters
              initialState={{ pagination: { pageSize: 50 } }}
              muiTableBodyCellProps={{ sx: { padding: "8px 10px" } }}
              muiTableHeadCellProps={{
                sx: { backgroundColor: "#f5f5f5", fontWeight: "bold" },
              }}
              renderTopToolbarCustomActions={() => (
                <div className="d-flex gap-2 align-items-center ms-2">
                  <button
                    className="btn btn-outline-primary btn-sm"
                    onClick={() => navigate("/employeeinfo/joblist")}
                  >
                    All Active Job Request
                  </button>
                </div>
              )}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default RegisteredUsers;
